// @ts-nocheck
import { graphql, Link as GatsbyLink } from "gatsby";
import React from "react";
import { Box, Heading, Link } from "theme-ui";
import {PortfolioPage} from '../components/Portfolio/portfolioPage';
import { CountDown } from "../components/countDown";

export default function portfolio({ data }) {
  
  return (
    <>
    {/* <CountDown/> */}
      <PortfolioPage/>
    </>
  );
}

